import React, { useEffect, useState, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { getCredenciales } from "../../../actions/webAfiliado/afiliadoVariosAction";
import { fetchCtaCtePorAfiliado } from '../../../actions/facturacion/facturasAfiliado';
import { useReactToPrint } from "react-to-print";
import { fetchConToken } from "../../../helpers/fetch";

import {
  Button,
  Table,
  TableBody,
  TableCell,
  Grid,
  TableHead,
  TableRow,
  makeStyles,
  Typography,
  Container,
  TablePagination,
} from "@material-ui/core";

import {
  fetchConsultaFacturacionAfiliado,
} from "../../../actions/facturacion/facturasAfiliado";
import { CuponPDFAfiliados } from "./CuponPDFAfiliados";

import { handleErrorApi } from "../../../helpers/randoms";
import { TIPO_COMPROBANTE } from '../../../utils/constants';

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: '100%',
    minWidth: '50%',
    marginTop: "1.5rem",
    marginBottom: "1rem"
  }
}));
const optionsfecha = {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
};
const FacturasAfiliado = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const pdfRef = useRef();

  const { credenciales } = useSelector(state => state.afiliadoVarios);
  const { items } = useSelector((state) => state.facturasAfiliado);
  const [numOrdenPago, setNumOrdenPago] = useState();
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [page, setPage] = useState(0);

  const afiliado = credenciales?.find(id => id.idAfiliado);
  var date = new Date();
  var result = new Date(date.getFullYear(), date.getMonth(), 1).toISOString(); //primer dia del mes en curso para comprobar las facturas del mes


  const handlePrint = useReactToPrint({
    content: () => pdfRef.current,
  });

  useEffect(() => {
    dispatch(getCredenciales())
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (afiliado) {
      dispatch(fetchCtaCtePorAfiliado(afiliado.idAfiliado));
    }
  }, [afiliado]);

  const handleChangePage = (e, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (e) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setPage(0);
  };

  const onClickBotonPagoHandler = async (comprobante) => {
    try {
      const parametros = `idAfiliado=${comprobante.idAfiliado}&idTipoComprobante=${comprobante.idTipoComprobante}&nroComprobante=${comprobante.nroComprobante}&fechaComprobante=${comprobante.fechaComprobante}`;
      const response = await fetchConToken(
        `BeneficiariosFacturas/traerIdCuponPago?${parametros}`
      );
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") !== -1) {
        const idCuponPago = await response.json();
        if (response.status !== 200) throw idCuponPago.errores;
        setNumOrdenPago(idCuponPago);
        dispatch(fetchConsultaFacturacionAfiliado(idCuponPago, handlePrint));
      }
    } catch (error) {
      handleErrorApi(
        dispatch,
        error,
        "Error al traer el Cupon de Pago",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };

  return (
    <div className={classes.root}>
      <div style={{ display: "none" }}>
        <CuponPDFAfiliados ref={pdfRef} numOrdenPago={numOrdenPago} />
      </div>
      <Container maxWidth="md">
        <Typography align="center" variant="h4" color="primary" className={classes.title}>Facturas</Typography>
        <Typography align="center" color="secondary">A continuación, podrás ver tus facturas y descargar el cupón de pago.</Typography>
        <Table size={"medium"}>
          <TableHead>
            <TableRow>
              <TableCell align="left">Fecha</TableCell>
              <TableCell align="left">Nro Comprobante</TableCell>
              <TableCell align="left">Tipo</TableCell>
              <TableCell align="left">Periodo</TableCell>
              <TableCell align="left">Fecha Vencimiento</TableCell>
              <TableCell align="center" style={{ minWidth: 100 }}>
                Importe
              </TableCell>
              <TableCell align="center" style={{ minWidth: 80 }}>
                Interés
              </TableCell>
              <TableCell align="center">Total</TableCell>
              <TableCell align="center"></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {items.length > 0 ? (
              <>
                {items.map((DatosFactura) => {
                  return (
                    <TableRow>
                      <TableCell>
                        {new Date(DatosFactura.fechaComprobante).toLocaleString(
                          "es",
                          optionsfecha
                        )}
                      </TableCell>
                      <TableCell>
                        {DatosFactura.nroComprobante}
                      </TableCell>
                      <TableCell>
                        {DatosFactura.descripcionTipoComprobante}
                      </TableCell>
                      <TableCell>
                        {DatosFactura.periodo.toLocaleString("en-US", {
                          minimumIntegerDigits: 6,
                          useGrouping: false,
                        })}
                      </TableCell>
                      <TableCell>
                        {new Date(DatosFactura.fechaVencimiento).toLocaleString(
                          "es",
                          optionsfecha
                        )}
                      </TableCell>
                      <TableCell>
                        {`$${DatosFactura.importe.toFixed(2)}`}
                      </TableCell>
                      <TableCell>
                        {`$${DatosFactura.interes.toFixed(2)}`}
                      </TableCell>
                      <TableCell>
                        {`$${DatosFactura.saldoConInteres.toFixed(2)}`}
                      </TableCell>
                      <TableCell align="left">
                        {DatosFactura.idTipoComprobante === TIPO_COMPROBANTE.FACTURA &&
                          DatosFactura.saldo > 0 && (
                            <Button
                              variant="contained"
                              style={{
                                marginLeft: 15,
                                minWidth: 135,
                                marginRight: -20,
                              }}
                              color="primary"
                              disabled={DatosFactura.fechaComprobante < result}
                              onClick={() =>
                                onClickBotonPagoHandler(DatosFactura)
                              }
                            >
                              Cupon Pago
                            </Button>
                          )}
                      </TableCell>
                    </TableRow>
                  )
                }
                )}
              </>

            ) : (
              <TableRow style={{ height: 50 }}>
                <TableCell
                  colSpan={8}
                  style={{ textAlign: "-webkit-center" }}
                >
                  {" "}
                  Sin Registros
                </TableCell>
              </TableRow>
            )}

          </TableBody>
        </Table>
        <Grid item xs={12} sm={4} md={12}>
          <TablePagination
            style={{ backgroundColor: 'white' }}
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={items.length}
            rowsPerPage={rowsPerPage}
            labelRowsPerPage='Registros por página'
            page={page}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
          />
        </Grid>
      </Container>
    </div>
  );
};
export default FacturasAfiliado